import { Color, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const MatchDifferenceContainer = styled.div`
  position: relative;
`

interface MatchDifferenceSaldoProps {
  differenceTypeSet: boolean
}

export const MatchDifferenceSaldo = styled.div<MatchDifferenceSaldoProps>`
  display: flex;
  justify-content: space-between;
  min-width: 0px;
  padding: ${Spacing.S8};
  ${({ differenceTypeSet }) => css`
    border: 1px solid ${differenceTypeSet ? '#cfcfcf' : Color.Yellow400};
    border-top: ${differenceTypeSet ? '#cfcfcf' : 'none'};
    background-color: ${differenceTypeSet ? Color.White : Color.Yellow100};
  `}
  border-radius: 0px 0px 4px 4px;
  transform: translateY(-3px);
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
`

interface SaldoOverlayProps {
  isOpen?: boolean
}

export const SaldoOverlay = styled.div<SaldoOverlayProps>`
  display: flex;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  width: 100%;
  min-width: 227px;
  padding: 10px;
  border-radius: 4px;
  position: absolute;
  top: 30px;
  left: 0px;
  z-index: 2;
  background-color: white;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};

  &:before {
    content: '';
    border-top: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid white;
    border-left: 8px solid transparent;
    position: absolute;
    top: -12px;
    left: 10px;
  }

  span {
    color: ${Color.Green700};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`
